import { marked } from 'marked'
import sanitize from 'widget-components/utilities/sanitize'

const renderer = new marked.Renderer()
renderer.link = (href, title, text) => `<a target="_blank" href="${href}" title="${title ?? ''}">${text}</a>`

const options: marked.MarkedOptions = { renderer, gfm: true, breaks: true }

export default (text = '') => {
    const html = marked.parseInline(sanitize(text), options)
    return html === text ? html : `<p data-markdown="true">${html}</p>`
}
